import { BENEFITS } from '../constants/sale.constants';
import TextListIcon from '@/components/icons/text-list';

export const SaleBenefitsHeader = () => {
  return (
    <div className="flex flex-col items-center text-center">
      <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-[#E3E5ED] ">
        <TextListIcon className="h-6 w-6 text-[#6E7384] " />
      </div>
      <h2 className="py-6 text-xl font-semibold">Продавайте Ориджиналы на Molwe</h2>
      <ul className="space-y-3 text-sm text-muted-foreground text-left">
        {BENEFITS.map((benefit) => (
          <li key={benefit.label} className="flex items-center gap-1.5">
            <span className="inline-flex h-6 w-6 items-center justify-center rounded-md bg-[#FFFFFF]">
              {benefit.icon}
            </span>
            <span>
              <span className="font-bold">{benefit.label}</span> {benefit.text}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
